import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { addItem } from '../../redux/actions/cartActions';
import { AddProductToCart, GetItemsInCart } from '../../queries/cart'
import { withApollo, Mutation } from 'react-apollo';
import clsx from 'clsx';
import {
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
  withStyles,
  Button,
} from '@material-ui/core';
import Notification from '../Notification';
import Rating from '@material-ui/lab/Rating';
import uuid from 'uuid';
// const Sale = process.env.PUBLIC_URL + '/img/for_store/catalog/sale_lable.png';
// const New = process.env.PUBLIC_URL + '/img/for_store/catalog/new_lable.png';

const useStyles = theme => ({
  '@media screen and (max-width: 2560px)': {
    root: {
      display: 'flex',
      flexDirection: 'column',
      fontFamily: 'Lato',
      width: '90%',
      background: '#FFFFFF 0% 0% no-repeat padding-box',
      boxShadow: '0px 3px 6px #00000029',
      borderRadius: '13px',
      opacity: 1
    },
    button: {
      borderRadius: '44px',
      textTransform: 'capitalize',
      opacity: 1
    },
    productNameGold: {
      color: '#F2A814',
      fontFamily: 'Lato',
      fontSize: '1rem',
      fontWeight: 'bold',
      textTransform: 'uppercase'
    },
    productNameGreen: {
      color: '#5B9FAB',
      fontFamily: 'Lato',
      fontSize: '1rem',
      fontWeight: 'bold',
      textTransform: 'uppercase'
    },
    companyName: {
      color: 'black',
      fontSize: '10px',
      borderRadius: '0px',
      textTransform: 'capitalize',
      marginTop: '5px'
    },
    containedBttn: {
      background: '#5B9FAB',
      color: 'white',
      textAlign: 'left',
      font: 'normal normal medium 18px/22px Lato',
      letterSpacing: '0px',
      '&:hover': {
        background: '#5B9FAB'
      }
    },
    outlinedBttn: {
      backgroundColor: 'white',
      border: '2px solid #5B9FAB',
      color: '#5B9FAB',
    },
    productPrice: {
      paddingTop: '10px',
      textAlign: 'left',
      font: 'normal normal bold 17px/17px Lato',
      letterSpacing: '0px',
      color: '#47515F',
      opacity: 1
    },
    buttonContainer: {
      marginTop: '-15px'
    },
    productRating: {
      fontSize: '1.1rem',
      color: '#F2A814',
      opacity: 1,
      top: '.2em'
    },
    productRatingNumber: {
      fontSize: '.7rem',
    },
    productRating_and_companyNameBox: {
      marginTop: '-2em'
    }
  },
  '@media screen and (max-width: 1440px)': {
    root: {
      display: 'flex',
      flexDirection: 'column',
      fontFamily: 'Lato',
      width: '90%',
      background: '#FFFFFF 0% 0% no-repeat padding-box',
      boxShadow: '0px 3px 6px #00000029',
      borderRadius: '13px',
      opacity: 1
    },
    button: {
      borderRadius: '44px',
      textTransform: 'capitalize',
      opacity: 1
    },
    productNameGold: {
      color: '#F2A814',
      fontFamily: 'Lato',
      fontSize: '1rem',
      fontWeight: 'bold',
      textTransform: 'uppercase'
    },
    productNameGreen: {
      color: '#5B9FAB',
      fontFamily: 'Lato',
      fontSize: '1rem',
      fontWeight: 'bold',
      textTransform: 'uppercase'
    },
    companyName: {
      color: 'black',
      fontSize: '10px',
      borderRadius: '0px',
      textTransform: 'capitalize',
      marginTop: '5px'
    },
    containedBttn: {
      background: '#5B9FAB',
      color: 'white',
      textAlign: 'left',
      font: 'normal normal medium 18px/22px Lato',
      letterSpacing: '0px',
      '&:hover': {
        background: '#5B9FAB'
      }
    },
    outlinedBttn: {
      backgroundColor: 'white',
      border: '2px solid #5B9FAB',
      color: '#5B9FAB',
    },
    productPrice: {
      paddingTop: '10px',
      textAlign: 'left',
      font: 'normal normal bold 17px/17px Lato',
      letterSpacing: '0px',
      color: '#47515F',
      opacity: 1
    },
    buttonContainer: {
      marginTop: '-15px'
    },
    productRating: {
      fontSize: '1.1rem',
      color: '#F2A814',
      opacity: 1,
      top: '.2em'
    },
    productRatingNumber: {
      fontSize: '.7rem',
    },
    productRating_and_companyNameBox: {
      marginTop: '-2em'
    }
  },

  '@media screen and (max-width: 1024px)': {
    root: {
      display: 'flex',
      flexDirection: 'column',
      fontFamily: 'Lato',
      width: '90%',
      background: '#FFFFFF 0% 0% no-repeat padding-box',
      boxShadow: '0px 3px 6px #00000029',
      borderRadius: '13px',
      opacity: 1
    },
    button: {
      borderRadius: '44px',
      textTransform: 'capitalize',
      opacity: 1
    },
    productNameGold: {
      color: '#F2A814',
      fontFamily: 'Lato',
      fontSize: '1rem',
      fontWeight: 'bold',
      textTransform: 'uppercase'
    },
    productNameGreen: {
      color: '#5B9FAB',
      fontFamily: 'Lato',
      fontSize: '1rem',
      fontWeight: 'bold',
      textTransform: 'uppercase'
    },
    companyName: {
      color: 'black',
      fontSize: '10px',
      borderRadius: '0px',
      textTransform: 'capitalize',
      marginTop: '5px'
    },
    containedBttn: {
      background: '#5B9FAB',
      color: 'white',
      textAlign: 'left',
      font: 'normal normal medium 18px/22px Lato',
      letterSpacing: '0px',
      '&:hover': {
        background: '#5B9FAB'
      }
    },
    outlinedBttn: {
      backgroundColor: 'white',
      border: '2px solid #5B9FAB',
      color: '#5B9FAB',
    },
    productPrice: {
      paddingTop: '10px',
      textAlign: 'left',
      font: 'normal normal bold 17px/17px Lato',
      letterSpacing: '0px',
      color: '#47515F',
      opacity: 1
    },
    buttonContainer: {
      marginTop: '-15px'
    },
    productRating: {
      fontSize: '1.1rem',
      color: '#F2A814',
      opacity: 1,
      top: '.2em'
    },
    productRatingNumber: {
      fontSize: '.7rem',
    },
    productRating_and_companyNameBox: {
      marginTop: '-2em'
    }
  },

  '@media screen and (max-width: 768px)': {
    root: {
      display: 'flex',
      flexDirection: 'column',
      fontFamily: 'Lato',
      width: '100%',
      background: '#FFFFFF 0% 0% no-repeat padding-box',
      boxShadow: '0px 3px 6px #00000029',
      borderRadius: '13px',
      opacity: 1,
      paddingTop: '22px',
      position: 'relative',
      left: '-20px'
    },
    noPadding: {
      padding: '0px !important'
    },
    image: {
      display: 'block',
      marginLeft: 'auto',
      marginRight: 'auto',
      width: '50%',
      marginTop: '-9px'
    },
    button: {
      borderRadius: '44px',
      textTransform: 'capitalize',
      opacity: 1,
      width: '80%',
      display: 'block',
      marginLeft: 'auto',
      marginRight: 'auto'

    },
    productNameGold: {
      color: '#F2A814',
      fontFamily: 'Lato',
      fontSize: '1rem',
      fontWeight: 'bold',
      textTransform: 'uppercase',
      textAlign: 'center',
      paddingRight: '.5em'
    },
    productNameGreen: {
      color: '#5B9FAB',
      fontFamily: 'Lato',
      fontSize: '1rem',
      fontWeight: 'bold',
      textTransform: 'uppercase',
      textAlign: 'center',
      paddingRight: '.5em'
    },
    companyName: {
      color: 'black',
      fontSize: '10px',
      borderRadius: '0px',
      textTransform: 'capitalize',
      marginTop: '5px'
    },
    containedBttn: {
      background: '#5B9FAB',
      color: 'white',
      textAlign: 'center',
      font: 'normal normal medium 18px/22px Lato',
      letterSpacing: '0px',
      '&:hover': {
        background: '#5B9FAB'
      }
    },
    outlinedBttn: {
      backgroundColor: 'white',
      border: '2px solid #5B9FAB',
      color: '#5B9FAB',
    },
    productPrice: {
      paddingTop: '10px',
      textAlign: 'center',
      font: 'normal normal bold 17px/17px Lato',
      letterSpacing: '0px',
      color: '#47515F',
      opacity: 1
    },
    buttonContainer: {
      marginTop: '-15px'
    },
    productRating: {
      fontSize: '1.1rem',
      color: '#F2A814',
      opacity: 1,
      top: '.2em'
    },
    productRatingNumber: {
      fontSize: '.7rem',
    },
    productRating_and_companyNameBox: {
      textAlign: 'center',
    }
  },
  '@media screen and (max-width: 425px)': {
    root: {
      display: 'flex',
      flexDirection: 'column',
      fontFamily: 'Lato',
      width: '120%',
      background: '#FFFFFF 0% 0% no-repeat padding-box',
      boxShadow: '0px 3px 6px #00000029',
      borderRadius: '13px',
      opacity: 1,
      paddingTop: '22px',
      position: 'relative',
      left: '-20px'
    },
    noPadding: {
      padding: '0px !important'
    },
    image: {
      display: 'block',
      marginLeft: 'auto',
      marginRight: 'auto',
      width: '50%',
      marginTop: '-9px'
    },
    button: {
      borderRadius: '44px',
      textTransform: 'capitalize',
      opacity: 1,
      width: '80%',
      display: 'block',
      marginLeft: 'auto',
      marginRight: 'auto'

    },
    productNameGold: {
      color: '#F2A814',
      fontFamily: 'Lato',
      fontSize: '1rem',
      fontWeight: 'bold',
      textTransform: 'uppercase',
      textAlign: 'center',
      paddingRight: '.5em'
    },
    productNameGreen: {
      color: '#5B9FAB',
      fontFamily: 'Lato',
      fontSize: '1rem',
      fontWeight: 'bold',
      textTransform: 'uppercase',
      textAlign: 'center',
      paddingRight: '.5em'
    },
    companyName: {
      color: 'black',
      fontSize: '10px',
      borderRadius: '0px',
      textTransform: 'capitalize',
      marginTop: '5px'
    },
    containedBttn: {
      background: '#5B9FAB',
      color: 'white',
      textAlign: 'center',
      font: 'normal normal medium 18px/22px Lato',
      letterSpacing: '0px',
      '&:hover': {
        background: '#5B9FAB'
      }
    },
    outlinedBttn: {
      backgroundColor: 'white',
      border: '2px solid #5B9FAB',
      color: '#5B9FAB',
    },
    productPrice: {
      paddingTop: '10px',
      textAlign: 'center',
      font: 'normal normal bold 17px/17px Lato',
      letterSpacing: '0px',
      color: '#47515F',
      opacity: 1
    },
    buttonContainer: {
      marginTop: '-15px'
    },
    productRating: {
      fontSize: '1.1rem',
      color: '#F2A814',
      opacity: 1,
      top: '.2em'
    },
    productRatingNumber: {
      fontSize: '.7rem',
    },
    productRating_and_companyNameBox: {
      textAlign: 'center',
    }
  },
});

class Catalog extends PureComponent {
  state = {
    showAlert: false,
    itemAdded: null
  }

  splitProductName(productName) {
    const productArray = productName.split(' ')
    return productArray
  }

  static propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({
      productName: PropTypes.string,
      productCategory: PropTypes.string,
      productImage: PropTypes.string,
      productDescription: PropTypes.string,
      productPrice: PropTypes.string,
      productId: PropTypes.string,
      amount: PropTypes.string
    })),
  };

  addItemToCart(cartItems, productID, productName,
    productShortDescription, price, quantity, images,
    companyEmail, companyName) {
    let itemExists = false;
    const newItem = {
      productID, productName,
      productShortDescription, price, quantity, images,
      companyEmail, companyName
    }
    if (cartItems.length === 0) {
      cartItems.push(newItem);
    }
    else {
      cartItems.forEach((cartItem) => {
        if (cartItem.productID === productID) {
          cartItem.quantity = cartItem.quantity + 1;
          itemExists = true;
        }
      })

      if (itemExists === false) {
        cartItems.push(newItem);
      }

    }
    this.props.addItem(cartItems);
    this.toggleAlert(productName);
  }

  toggleAlert = (item) => {
    this.setState({
      itemAdded: item,
      showAlert: !this.state.showAlert
    }, () => {
      window.setTimeout(() => {
        this.setState({showAlert: !this.state.showAlert})
      },6000)
    });
  }

  determineProductQuantity(productID, cartItems) {
    const filteredCartItems = cartItems.filter((cartItem) => {
      return cartItem.productID === productID;
    })

    if (filteredCartItems.length === 0) {
      return 1;
    } else {
      let quantity = filteredCartItems[0].quantity;
      quantity = quantity + 1;
      return quantity;
    }
  }

  render() {
    const cartItems = this.props.cartItems.items;
    const { classes } = this.props;

    return (
      <Grid container justify="flex-start" spacing={2}>
        {this.state.showAlert ?
          <Grid item xs={12}>
            <div id="addedAlert">
              <Notification
                position='tr'
                title='Success'
                message={`${this.state.itemAdded} Added!`}
                className='success'
              />
            </div>
          </Grid>
        : null}
        {
          this.props.items.map((item, i) => {
            return (
              <Grid key={uuid()} item xs={12} sm={6} md={6} lg={4} xl={3}>
                <Card
                  className={classes.root}
                >
                  <CardContent>
                    <Box
                      display="flex"
                      justifyContent="center"
                      mb={3}
                    >
                      <Grid container spacing={2}>
                        <Grid className={classes.noPadding} item xs={12} sm={12} md={6}>
                          <div>
                            {/*if(this.getWindowDimensions.width === */}
                            {this.splitProductName(item.productName).map((nameElement, index) => {
                              if (index === 0) {
                                return (
                                  <div key={uuid()} className={classes.productNameGold}>{nameElement}</div>
                                )
                              }
                              else {
                                return (
                                  <div key={uuid()} className={classes.productNameGreen}>{nameElement}</div>
                                )
                              }
                            })}
                          </div>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6}>
                          <img className={clsx(classes.image, classes.noPadding)} src={item.images[0]} alt={item.productDescription} />
                        </Grid>
                      </Grid>
                    </Box>
                    <Box
                      className={classes.productRating_and_companyNameBox}
                    >
                      <Rating
                        name="product-rating"
                        value={0}
                        className={classes.productRating}
                        readOnly
                      />
                      <span
                        className={classes.productRatingNumber}
                      >
                        (0)
                      </span>
                      <br />
                      <Button
                        variant="contained"
                        disabled
                        className={classes.companyName}
                      >
                        {String(`By: ${item.companyName}`)}
                      </Button>
                    </Box>

                    <Box flexGrow={1} />
                    <Box>
                      <Typography
                        align="left"
                        variant="body1"
                        className={classes.productPrice}
                      >
                        {`$${Number(item.price).toFixed(2) / 100}.${(String(item.price)).slice(-2)}`}
                      </Typography>
                    </Box>
                  </CardContent>
                  <Box p={2} className={classes.buttonContainer}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                        <Button
                          variant="outlined"
                          className={clsx(classes.button, classes.outlinedBttn)}
                          onClick={() => { this.props.history.push(`/app/marketplace/product/${item.productID}`) }}
                          fullWidth={true}
                        >
                          View More
                      </Button>
                      </Grid>
                      <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                        <Mutation
                          mutation={AddProductToCart}
                          refetchQueries={[{
                            query: GetItemsInCart(),
                            fetchPolicy: "network-only"
                          }]}
                          onCompleted={() => {
                            this.addItemToCart(
                              cartItems,
                              item.productID,
                              item.productName,
                              item.productShortDescription,
                              item.price,
                              1,
                              item.images,
                              item.companyEmail,
                              item.companyName
                            );
                          }}>
                          {(addProductToCart) => (
                              <Button
                                variant="contained"
                                className={clsx(classes.button, classes.containedBttn)}
                                fullWidth={true}
                                onClick={() => {
                                  addProductToCart({
                                    variables: {
                                      productId: item.productID,
                                      productName: item.productName,
                                      productShortDescription: item.productShortDescription,
                                      price: item.price,
                                      quantity: this.determineProductQuantity(item.productID, cartItems),
                                      images: item.images,
                                      companyEmail: item.companyEmail,
                                      vendorName: item.companyName
                                    }
                                  })
                                }}
                              >
                                Add To Cart
                              </Button>
                          )}
                        </Mutation>
                      </Grid>
                    </Grid>
                  </Box>
                </Card>
              </Grid>)
          })
        }
      </Grid>
    )
  }
}

function mapStateToProps(state) {
  return {
    cartItems: state.cartData
  }
}

export default withRouter(withApollo(connect(mapStateToProps, { addItem })(withStyles(useStyles)(Catalog))))



// WEBPACK FOOTER //
// ./src/components/catalog/ProductItems.js